import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import {getRelatedPurchaseList} from '@/api/miscellaneous';
import moment from 'moment';
import {useRouter} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'RelatedPurchaseList',
  props: {
    active: {
        type: String,
        default: '',
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props

const router = useRouter();


const list = ref<any[]>([]);
const getListData = ref({
    page: 1,
    size: 10,
});
const loading = ref(false);
const finished = ref(false);

const getList = () => {
    // if (loading.value) return;
    // loading.value = true;
    getRelatedPurchaseList(getListData.value).then((res: any) => {
        list.value = [...list.value, ...res.items];
        getListData.value.page += 1;
        loading.value = false;
        finished.value = getListData.value.page * getListData.value.size >= res.total;
    });
};
getList();

const __returned__ = { router, props, list, getListData, loading, finished, getList, ref, getRelatedPurchaseList, moment, useRouter }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})